import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_booking extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    // this.is_dummy = true;
  }  
  getUserUserGroupProfile(username, school_id){
    var self = this;
    const url = `${this.api_base_url}/api/iot/getUserUserGroupProfile.php`;
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          username: username,
          school_id: school_id,
        }
      }).then(response => response.data);
    }
  }
  getMyFutureBooking(username, school_id){
    var self  = this;
    const url = `${this.api_base_url}/api/iot/getMyFutureBooking.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          username: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          username: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          username: username,
        }
      }).then(response => response.data);
    }
  }
  getExperimentSetStatus(school, experiment, equipment_id){
    var self = this;
    const url = `${this.api_base_url}/api/iot/getExperimentSetStatus.php`;
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getSlotsByDate(date, school, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSlotsByDate.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          user_id: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          user_id: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          date: date,
          school: school,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  releaseSlot(slot_id, auth_token) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/releaseSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('slot_id', slot_id);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  enterLab(slot, username, school, experiment, equipment_id, auth_token, role, user_level) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/enterLab.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('slot', slot);
    bodyFormData.set('username', username);
    bodyFormData.set('school', school);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('auth_token', auth_token);
    bodyFormData.set('role', role);
    bodyFormData.set('user_level', user_level);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getSchool(school) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchool.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          user_id: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          user_id: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school: school,
        }
      }).then(response => response.data);
    }
  }
  getEquipmentAndBookingStatus(booking_id, school_id, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getEquipmentAndBookingStatus.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          booking_id: booking_id, 
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getSchoolExperimentSet(school, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolExperimentSet.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          user_id: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          user_id: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school: school,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  bookSlot(slot_id, auth_token, username, user_level) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/bookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('slot_id', slot_id);
    bodyFormData.set('auth_token', auth_token);
    bodyFormData.set('username', username);
    bodyFormData.set('user_level', user_level);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }

}
